import { DatePickerButton } from "@/components/DatePickerButton";

interface CodingDashboardDatePickersProps {
  fromDate: Date | null;
  toDate: Date | null;
  onFromDateChange: (date: Date | null) => void;
  onToDateChange: (date: Date | null) => void;
}

export function CodingDashboardDatePickers({
  fromDate,
  toDate,
  onFromDateChange,
  onToDateChange,
}: CodingDashboardDatePickersProps) {
  return (
    <div className="flex items-center gap-2">
      <DatePickerButton
        date={fromDate}
        placeholder="From"
        ariaLabel="Select start date"
        clearAriaLabel="Clear start date"
        onDateChange={onFromDateChange}
      />
      <span className="text-muted-foreground text-sm">&ndash;</span>
      <DatePickerButton
        date={toDate}
        placeholder="To"
        ariaLabel="Select end date"
        clearAriaLabel="Clear end date"
        onDateChange={onToDateChange}
      />
    </div>
  );
}
